import { TransformFnParams } from 'class-transformer';
import moment from 'moment-timezone';

export class ValidationFormatConstants {
  static emailPattern: RegExp =
    /^(?!.*?\.\.)(?:[ ]*(?:[^\W.])[A-Za-z0-9-._%'+#-]*@(?:[A-Za-z0-9-._]+)(?:\.[A-Za-z]{2,})+[ ]*)$/;
  static phonePattern: RegExp =
    /^\s*\(?\s*[0-9]\d{2}\)?-?\s*\d{3}\s*-?\s*\d{4}$/;
  static phoneRules: any = { X: /[0-9]/ };
  static dateFormat = 'MM/dd/yyyy';
  static dateISOFormat = 'yyyy-MM-ddT00:00:00';
  static accountNumberPattern: RegExp = /^([R,r])\d{7}[L,U,l,u]\d{7}$/;
  static webUrlPattern: RegExp =
    /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim;
  static dateTimeFormat = 'MM/dd/yyyy hh:mm:ss a'; // 12 hour clock
  static currencyFormat = '$#,##0.00;($#,##0.00)';
}

export const dateJSONTransformer = (params: TransformFnParams) => {
  return !!params.value
    ? moment(params.value).format('YYYY-MM-DD')
    : params.value;
};
